import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { PopoverKind } from '../PopoverContent';
import Tooltip from '@mui/material/Tooltip';

export default ({
  popoverKind,
  openPopover
}: {
  popoverKind: PopoverKind;
  openPopover: (
    anchorEl: HTMLButtonElement | null,
    popoverKind: PopoverKind
  ) => void;
}) => {
  const btnTitle = 'Remove';

  const handleRemoveClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    openPopover(event.currentTarget, popoverKind);
  };

  return (
    <Tooltip title={btnTitle} followCursor>
      <IconButton
        aria-label={btnTitle}
        onClick={handleRemoveClick}
        size="small"
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
